<template>
  <v-text-field
    class="w-password-field"
    v-bind="filterProps($props, ['label'])"
    :label="computedLabel"
    :append-icon="showPassword ? '$wView' : '$wEditView'"
    :type="showPassword || disableAutofill ? 'text' : 'password'"
    outlined
    dense
    hide-details="auto"
    :autocomplete="autocomplete"
    v-on="$listeners"
    @click:append="showPassword = !showPassword"
    @focus="handleType"
    @blur="handleType"
  />
</template>

<script>
import { VTextField } from 'vuetify/lib';
import { filterProps } from '@/utils/functional-component-utils';
import requireable from '@/mixins/component/requireable-mixin';

export default {
  mixins: [requireable],
  props: {
    ...VTextField.options.props,
    autocomplete: { type: String, default: 'off' },
  },
  data() {
    return {
      showPassword: false,
      disableAutofill: true,
    };
  },
  methods: {
    filterProps: filterProps,
    handleType(event) {
      const { srcElement, type } = event;
      const { value } = srcElement;

      if (type === 'blur' && !value) {
        this.disableAutofill = true;
      } else {
        this.disableAutofill = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.w-password-field {
  > ::v-deep.v-input__control .v-input__slot {
    background-color: $input-bg-color !important;
  }
  ::v-deep .v-input__append-inner {
    margin-bottom: auto !important;
  }
}
</style>
